import { createGlobalStyle } from 'styled-components';
import 'react-circular-progressbar/dist/styles.css';

export default createGlobalStyle`

  /**
  *  Responsividade
  ## CSS Units  ( Unidades de medidas do CSS)

  ### Layout Fixo
  px - Pixels

  ### Layout Responsivo
  % - Porcentagem
  auto - Automática
  vh - Viewport Height
  vw - Viewport Weidh

  ### Texto Fixos
  1px = 0.75pt
  16px = 12pt

  ### Texto Responsivos
  em = Multiplicado pelo Pai (cuidado pode ocorrencer em cascata)
  rme = Multiplicado pelo Root  (font-size: 62.5%; A cada 1rem será considerado 10px )

  # Media queries
  @media (max-width: 768px) {} será aplicado de 0 <= 768px
  @media (min-width: 768px) {} será aplicado de >= 768px

  */

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html {
    min-height: 100vh;
    /* a cada 1rem será considerado 10px */
    font-size: 62.5%;
  }


  body, input , button {
    font: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 1.6rem;
    transition: color .2s ease-out;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }



  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }

  :root {
    --enable: #28a745;
    --disable: #b2bac7;
    --error: #c53030;
    --background-text-error: #fff;

    /* PALETA Yorkshire - Inspirada nos tons terrosos e elegantes do marrom */
    --primary: #8d6e63;          /* Marrom principal elegante */
    --primary-hover: #795548;    /* Marrom mais escuro no hover */
    --primary-light: #bcaaa4;    /* Marrom claro suave */
    --primary-text: #fff;
    --success: #28a745;
    --danger: #dc3545;

    --button-text: #fff;
    --button-blue: #007bff;
    --button-blue-hover: #0069d9;
    --button-blue-border: #0062cc;
    --button-primary: #8d6e63;
    --button-primary-hover: #795548;
    --button-primary-border: #6d4c41;
    --button-secondary: #6c757d;
    --button-secondary-hover: #5a6268;
    --button-secondary-border: #545b62;
    --button-success: #28a745;
    --button-success-hover: #218838;
    --button-success-border: #1e7e34;
    --button-warning: #ffc107;
    --button-warning-hover: #e0a800;
    --button-warning-border: #d39e00;
    --button-danger: #dc3545;
    --button-danger-hover: #c82333;
    --button-danger-border: #bd2130;
    --button-info: #17a2b8;
    --button-info-hover: #138496;
    --button-info-border: #117a8b;
    --button-light: #f8f9fa;
    --button-light-hover: #e2e6ea;
    --button-light-border: #dae0e5;
    --button-dark: #343a40;
    --button-dark-hover: #23272b;
    --button-dark-border: #1d2124;

  }

  body.light-theme {

    /** Global */
    --background: #faf8f5;        /* Fundo bege clarinho, tom quente e acolhedor */
    --text: #3e2723;              /* Texto marrom escuro */
    --placeholder: #795548;       /* Placeholder marrom médio */
    --border: #efebe9;           /* Bordas marrom bem claro */
    --backgroun-icon-hover: rgba(141, 110, 99, 0.1);

    /** PopupMenu */
    --color-popoup-menu-hover: #8d6e63;

    /** Loader */
    --border-loading-active: #8d6e63;
    --border-loading: #efebe9;

    /** Header */
    --background-header: #8d6e63;
    --text-header: #fff;

    /** SideBar */
    --background-sidebar: #fff;
    --text-item-menu: #3e2723;
    --backgrount-item-menu-hover: #fbe9e7;  /* Hover marrom muito suave */
    --text-item-menu-hover: #8d6e63;
    --link-active-sidebar: #8d6e63;
    --link-border-active-sidebar: #8d6e63;

    /** SubMenu */
    --background-color-submenu: #faf8f5;

    /** Header Pages */
    --background-header-icon: #fff;
    --background-header-text: #fff;
    --background-header-page-1: #8d6e63;
    --background-header-page-2: #795548;

    /** PANEL */
    --background-panel: #fff;

    /** TABLE */
    --border-table: #efebe9;

    /** PAGINATION */
    --background-pagination-icon-hover: rgba(141, 110, 99, 0.04);
    --background-pagination-icon-disabled: #efebe9;
    --background-pagination-icon-enabled: #3e2723;

    /** Input */
    --background-input: #fff;
    --border-input: #795548;
    --selected-input: #8d6e63;

    /** Link */
    --link: #8d6e63;
    --link-hover: #795548;

     /** PDF View */
    --pdf-header: rgba(62, 39, 35, 1);     /* Marrom escuro para header do PDF */
    --pdf-header-button-hover: rgba(188, 170, 164, 1);

  }

  body.dark-theme {

    /** Global */
    --background: #1a0e0a;        /* Fundo marrom muito escuro */
    --text: #bcaaa4;              /* Texto marrom claro */
    --placeholder: #6d4c41;       /* Placeholder marrom médio escuro */
    --border: #4e342e;           /* Bordas marrom escuro */
    --backgroun-icon-hover: rgba(141, 110, 99, 0.3);

    /** Loader */
    --border-loading-active: #8d6e63;
    --border-loading: #4e342e;

    /** Header */
    --background-header: #3e2723;  /* Header marrom escuro */
    --text-header: #fff;

    /** SideBar */
    --background-sidebar: #3e2723; /* Sidebar marrom escuro */
    --text-item-menu: #a1887f;     /* Texto dos itens em marrom claro */
    --backgrount-item-menu-hover: rgba(141, 110, 99, 0.1);
    --text-item-menu-hover: #bcaaa4;
    --link-active-sidebar: #bcaaa4;
    --link-border-active-sidebar: #bcaaa4;

    /** SubMenu */
    --background-color-submenu: #1a0e0a;

    /** Header Pages */
    --background-header-icon: #fff;
    --background-header-text: #fff;
    --background-header-page-1: #8d6e63;
    --background-header-page-2: #795548;

    /** PANEL */
    --background-panel: #3e2723;

    /** TABLE */
    --border-table: #4e342e;

    /** PAGINATION */
    --background-pagination-icon-hover: #3e2723;
    --background-pagination-icon-disabled: #4e342e;
    --background-pagination-icon-enabled: #fff;

    /** Input */
    --background-input: #2e1a17;    /* Input com fundo marrom muito escuro */
    --border-input: #4e342e;
    --selected-input: #8d6e63;

     /** Link */
     --link: #bcaaa4;
     --link-hover: #8d6e63;

     /** PDF View */
     --pdf-header: rgba(26, 14, 10, 1);      /* PDF header marrom profundo */
     --pdf-header-button-hover: rgba(188, 170, 164, 1);

  }

  body {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    background: var(--background);
    color: var(--text);
    -webkit-font-smoothing: antialiased;
  }

  /** Route active SideBarMenu */
  .sideBarLinkActive  span,
  .sideBarLinkActive  svg {
    color: var(--link-active-sidebar) !important;
    font-weight: 700;
  }

  /** HELPERS */

  .text-left {
    text-align: left;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }

  /* for custom scrollbar for webkit browser*/
/*
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
}
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
} */

/* Customize website's scrollbar like Mac OS - Tema Yorkshire
Not supports in Firefox and IE */

/* total width */
::-webkit-scrollbar {
    background-color: var(--background);
    width:16px
}

/* background of the scrollbar except button or resizer */
::-webkit-scrollbar-track {
    background-color: var(--background);
}
::-webkit-scrollbar-track:hover {
    background-color: var(--border);
}

/* scrollbar itself */
::-webkit-scrollbar-thumb {
    background-color: #bcaaa4;      /* Tom marrom claro suave */
    border-radius:16px;
    border:5px solid var(--background);
}
::-webkit-scrollbar-thumb:hover {
    background-color: #8d6e63;      /* Marrom mais vibrante no hover */
    border:4px solid var(--border);
}

/* set button(top and bottom of the scrollbar) */
::-webkit-scrollbar-button {display:none}



`;
